module.exports = __webpack_public_path__ + "static/img/Logo_PIPE_EAGLE_V.a6a0c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/Logo_PIPE_EAGLE_V.png
// module id = 1632
// module chunks = 6